export const formatNumber = (value?: number | string, keepNegative?: boolean) => {
  if (value || value === 0) {
    if (value < 0 && keepNegative) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    } else {
      return String(value)
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  } else {
    return ''
  }
}
